import { Component, Prop, Vue } from 'vue-property-decorator';
import { TrackClickEvents } from '../../models';

@Component
export class TrackClickMixin extends Vue {
  @Prop({ required: true })
  public item: any;

  @Prop({ default: 800 })
  public doubleClickTimeoutInMs: number;

  @Prop({ required: true })
  public clickEvents: TrackClickEvents;

  public hasDoubleClicked = false;

  public emitClick(): void {
    if (this.isSingleClick()) {
      this.$x.emit(this.clickEvents.click, this.item);
    }
  }

  public emitRightClick(): void {
    if (this.isSingleClick()) {
      this.$x.emit(this.clickEvents.rightClick, this.item);
    }
  }

  public isSingleClick(): boolean {
    if (this.hasDoubleClicked) {
      return false;
    } else {
      setTimeout(() => this.hasDoubleClicked = false, this.doubleClickTimeoutInMs);
      return this.hasDoubleClicked = true;
    }
  }
}
